import { Typography } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { formatPrice } from "../services/formatPrice";
import "../styles/sortbybar.css";

type PaymentProductRowProps = {
    product: any,
}
 
export function PaymentProductRow({ product }: PaymentProductRowProps) {
    //const [totalProductPrice, setTotalProductPrice] = useState(product.totalPrice);

    return (
          <div className="flex gap-5 border-b-2 border-b-gray-500 pb-4 mb-3">
              <div className="flex gap-2">
                <img src={!product.productSize ? 
                "https://swdstore.blob.core.windows.net/exe101/aobongchay.jpg" : 
                (product.productSize.product.productImages.length > 0 ? 
                product.productSize.product.productImages[0].imageUrl : 
                "https://swdstore.blob.core.windows.net/exe101/aobongchay.jpg")}
                alt="" className="w-16 h-16"/>
                <div className={"hidden"}>{product.totalPrice}</div>
              </div>
              <div className="flex-grow">
                  <div className="flex justify-between">
                    <h5>{product.productSize && product.productSize.name}</h5>
                  </div>
                  <div className="flex justify-between">
                    <Typography color="red" placeholder={""}>{formatPrice(product.totalPrice)}</Typography>
                    <div className="flex items-center">&times; {product.quantity}</div>
                  </div>
               </div>
            </div>
     );
}
